<sdps-divider variation="secondary"></sdps-divider>
<span id="section-title">Transaction details</span>
<ng-container *ngIf="hasBadRequestServiceError && !isAchTweAuthorizationError">
  <mm-banners *ngFor="let error of serviceErrorList" [parentForm]="transactionDetailsGroup" [bannerText]="[error]"
    [type]="'error'" id="transactionDetailsAch_badRequestServiceError"
    data-testid="transactionDetailsAch_badRequestServiceError"></mm-banners>
</ng-container>
<mm-banners *ngIf="transactionFormState?.hasError && !hasBadRequestServiceError" [bannerText]="[errorBannerText]"
  [type]="'error'" data-testid="transactionDetailsAch_serviceError">
</mm-banners>
<mm-banners *ngIf="isOutgoing" class="ach-funds-settlement-banner" [bannerText]="[achFundsSettlementBannerText]" [type]="'information'"
  data-testid="transactionDetailsAch_achFundsSettlementBanner">
</mm-banners>
<form [formGroup]="transactionDetailsFormGroup" id="transaction-details-container">
  <div class="row">
    <mm-recurring-frequency-selector *ngIf="(isRecurring$ | async)" [parentForm]="transactionDetailsGroup"
      [frequencyList]="(frequencyList$ | async)!" (frequencyChanged)="onFrequencyChanged($event)"
      class="big-bottom-spacer">
    </mm-recurring-frequency-selector>
  </div>
  <div [ngClass]="!isIncoming ? 'recurring-date-container big-bottom-spacer' : ''">
    <div class="row">
      <mm-date-picker-control [parentForm]="transactionDetailsFormGroup" [label]="datePickerLabelName" [minDate]="minDate"
        [defaultDate]="defaultProcessDate" formControlName="completionDate" [formControlValidators]="datePickerValidators"
        [formControlValue]="defaultProcessDate" id="transactionDetailsAch_completionDatePicker"
        [id]="'completion-date-picker'" data-testid="completionDatePicker">
      </mm-date-picker-control>

      <div class="expectedWithdrawalDate">
        <div class="header" data-testid="expectedWithdrawalDateLabel">
          Expected withdrawal date
          <mm-tooltip [position]="'right'" [containsLink]="false"
            id="transactionDetailsAch_expectedWithdrawalDateTooltip">
            <tooltip-content>
              <div>{{expectedWithdrawalDateCopy}}</div>
            </tooltip-content>
            <tooltip-trigger-element>
              <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
            </tooltip-trigger-element>
          </mm-tooltip>
        </div>
        <span id="transactionDetailsAch_expectedWithdrawalDate" *ngIf="!hasWithdrawalDateServiceError; else elseBlock"
          class="withdrawalDate" data-testid="expectedWithdrawalDate">
          {{withdrawalDate$ | async | date : 'MM/dd/yyyy'}}</span>
        <ng-template #elseBlock>
          <span id="transactionDetailsAch_expectedWithdrawalDateError" [ngClass]="(isRecurring$ | async) && isIncoming && showContributionReason ? 'expected-withdrawal-error-width' : ''"
            class="withdrawalDateError">{{withdrawalDateServiceError}}</span>
        </ng-template>
      </div>
      <div *ngIf="isIncoming" class="fundsAvailableToTrade">
        <div class="header">
          Funds available to trade
          <mm-tooltip [position]="'right'" [containsLink]="false" id="transactionDetailsAch_fundsAvailableToTradeTooltip">
            <tooltip-content>
              <div>{{fundsAvailableToTradeCopy}}</div>
            </tooltip-content>
            <tooltip-trigger-element>
              <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
            </tooltip-trigger-element>
          </mm-tooltip>
        </div>
        <span id="transactionDetailsAch_fundsAvailableToTrade" class="completionDate">
          {{fundsAvailableToTrade$ | async | date : 'MM/dd/yyyy'}}</span>
      </div>
    </div>
    <div [ngClass]="(isRecurring$ | async) ? 'row filed-gap big-bottom-spacer': 'big-bottom-spacer'">
        <div class="row" *ngIf="showSecondCompletionDate">
          <mm-date-picker-control class="small-top-spacer"
            [parentForm]="transactionDetailsFormGroup" [label]="secondCompletionDateLabel" [minDate]="today"
            [formControlValidators]="secondCompletionDateValidators" [id]="'ach-second-completion-date-picker'"
            id="transactionDetailsAch_secondCompletionDate" formControlName="secondProcessDate"
            data-testid="secondCompletionDatePicker">
          </mm-date-picker-control>
        </div>
      <div class="row" *ngIf="showEndDate">
        <mm-date-picker-control class="small-top-spacer"
          [parentForm]="transactionDetailsFormGroup" [label]="endDateLabel" [minDate]="today" [disableWeekends]="false"
          [showOptionalLabel]="true" [formControlValidators]="endDateValidators" [id]="showSecondCompletionDate ? 'ach-end-date-pickerwithFlag' : 'ach-end-date-picker'"
          id="transactionDetailsAch_endDate" formControlName="endDate" data-testid="endDatePicker">
        </mm-date-picker-control>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="selectDateForMonth && !IRARegTypeCodes">
    <mm-banners [bannerText]="[NonRothIraBanner]" [type]="'information'"></mm-banners>
  </div>
  <div [ngClass]="(isRecurring$ | async) ? 'row gy-1 filed-gap amount-container' : 'gy-1 amount-field'">
     <mm-amount-field *ngIf="isIra && isIncoming"
       [parentForm]="transactionDetailsFormGroup"
       [payIncome$]="payIncome$"
       id="transactionDetailsAch_transferAmount" class="big-bottom-spacer">
     </mm-amount-field>
     <mm-amount-field *ngIf="!(isIra && isIncoming)"
       [parentForm]="transactionDetailsFormGroup" [maxTransferAmount]="(this.maxTransferAmount$ | async)"
       [payIncome$]="payIncome$"
       id="transactionDetailsAch_transferAmount" class="big-bottom-spacer">
     </mm-amount-field>
    <mm-amount-type-selector *ngIf="displayTaxwithholdingsFields" [parentForm]="transactionDetailsFormGroup"
      [controlDisabled]="shouldDisableAmountType" [prefilledValue]="amountType" id="transactionDetailsAch_transferAmountType"
      [payIncome$]="payIncome$" [distributionReason$]="distributionReason$">
    </mm-amount-type-selector>
    <div class="direction-container">
      <div *ngIf="isIncoming"
      [ngClass] = "'incoming'"
       id="incoming">
        <div id="incoming-icon" data-testid="incoming-icon" class="incoming-icon"
         [ngClass]="(isRecurring$ | async) ? 'incoming-icon-margin' : ''">
        </div>
        <span id="incoming-text" class="incoming-text"
        [ngClass]="((isRecurring$ | async)) ? '' : 'incoming-indicator'">{{achIncomingIndicator}} </span>
      </div>
      <div *ngIf="!isIncoming" id="outgoing">
        <div id="outgoing-icon" data-testid="outgoing-icon" class="outgoing-icon"></div>
        <span id="outgoing-text">{{achOutgoingIndicator}} </span>
      </div>
    </div>
    <div *ngIf="showContributionReason"
      [ngClass]="(!(isRecurring$ | async)) ? 'ach-contribution-flex big-bottom-spacer' : 'select-dropdown'">
      <mm-ach-contribution-reason [parentForm]="transactionDetailsFormGroup"
        [contributionOptions$]="contributionOptions$">
      </mm-ach-contribution-reason>
    </div>
  </div>
  <hr *ngIf="displayTaxwithholdingsFields">
  <mm-create-request-tax-withholdings *ngIf="displayTaxwithholdingsFields" [parentForm]="transactionDetailsFormGroup"
    [taxWithholdings]="(taxWithholdings$ | async)!" [taxWithholdingsFormGroupDetails]="taxWithholdingsFormGroupDetails"
    [distributionReasonTooltip]="distributionReasonTooltip" [isReviewEdit]="isEdit" class="big-bottom-spacer">
  </mm-create-request-tax-withholdings>
  <hr *ngIf="isPtrs && isOutgoing">
  <mm-trust-fields id="transactionDetailsAchComponent_trustFields" *ngIf="isPtrs && isOutgoing"
    [parentForm]="transactionDetailsFormGroup" [showPaidFor]="isOutgoing" [availableCash]="availableCash"
    [datePickerControlName]="controlNames.completionDate" [overdraftRulesFutureDate]="overdraftRulesFutureDate"
    class="big-bottom-spacer transactionDetailsAchComponent_trustFields">
  </mm-trust-fields>
</form>
<mm-banners *ngIf="hasServiceError" [serviceError]="(transactionFormServiceError$ | async)!" [type]="'error'"
  id="transactionDetailsAch_serviceError" data-testid="transactionDetailsAch_serviceError"></mm-banners>
